// extracted by mini-css-extract-plugin
export default {"loading-skeleton":"Skeleton-module__loading-skeleton__NA3X4"};